import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Họ và tên", -1)
const _hoisted_4 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Tên đăng nhập", -1)
const _hoisted_6 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Ngày sinh", -1)
const _hoisted_8 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Số CMND", -1)
const _hoisted_10 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Email", -1)
const _hoisted_12 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Mật khẩu(tối thiểu 6 ký tự)", -1)
const _hoisted_14 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", null, "Chọn khoa/phòng làm việc", -1)
const _hoisted_16 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", null, "Chọn cơ sở đang làm việc", -1)
const _hoisted_18 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", null, "Chọn quyền hạn", -1)
const _hoisted_20 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", null, "Cho phép gởi chỉ đạo ", -1)
const _hoisted_22 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", null, "Nghiên cứu khoa học", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Đăng ký tài khoản nhân viên" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_InputText, {
            id: "fullname",
            type: "text",
            modelValue: $setup.register.fullname,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.register.fullname) = $event)),
            style: {"text-align":"center"}
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_InputText, {
            id: "username",
            type: "text",
            modelValue: $setup.register.username,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.register.username) = $event)),
            style: {"text-align":"center"}
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_Calendar, {
            id: "birthday",
            modelValue: $setup.register.birthday,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.register.birthday) = $event)),
            autocomplete: "off"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_InputText, {
            id: "cmnd",
            type: "text",
            modelValue: $setup.register.cmnd,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.register.cmnd) = $event)),
            style: {"text-align":"center"}
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_InputText, {
            id: "email",
            type: "text",
            modelValue: $setup.register.email,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.register.email) = $event)),
            style: {"text-align":"center"}
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_component_Password, {
            id: "password",
            modelValue: $setup.register.password,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.register.password) = $event)),
            toggleMask: "",
            feedback: true
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode(_component_Dropdown, {
            id: "team",
            modelValue: $setup.register.team,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.register.team) = $event)),
            options: $setup.teams,
            optionLabel: "name",
            optionValue: "code",
            placeholder: "Vui lòng lựa chọn khoa khám..."
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode(_component_Dropdown, {
            id: "address",
            modelValue: $setup.register.address,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.register.address) = $event)),
            options: $setup.addressHospital,
            optionLabel: "label",
            optionValue: "value",
            placeholder: "Vui lòng lựa chọn cơ sở đang làm việc..."
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode(_component_Dropdown, {
            id: "permission",
            modelValue: $setup.register.permission,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.register.permission) = $event)),
            options: $setup.userPermission,
            optionLabel: "name",
            optionValue: "value",
            placeholder: "Vui lòng chọn quyền hạn của tài khoản ..."
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createVNode(_component_Dropdown, {
            id: "emailpermission",
            modelValue: $setup.emailPer,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.emailPer) = $event)),
            options: $setup.emailPermission,
            optionLabel: "label",
            optionValue: "value"
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createVNode(_component_Dropdown, {
            id: "nckh",
            modelValue: $setup.nckhPer,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.nckhPer) = $event)),
            options: $setup.nckh,
            optionLabel: "label",
            optionValue: "value"
          }, null, 8, ["modelValue", "options"])
        ])
      ]),
      ($setup.valid)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            label: "Đăng ký",
            icon: "pi pi-plus-circle",
            iconPos: "left",
            onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.doRegister()))
          }))
        : (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            label: "Đăng ký",
            icon: "pi pi-plus-circle",
            iconPos: "left",
            disabled: "disabled"
          }))
    ]),
    _: 1
  }))
}